export {default as Back} from '@/assets/dir_b.png'
export {default as Right} from '@/assets/dir_e.png'
export {default as Forward} from '@/assets/dir_f.png'
export {default as Down} from '@/assets/dir_land.png'
export {default as Top} from '@/assets/dir_n.png'
export {default as TopRight} from '@/assets/dir_ne.png'
export {default as TopLeft} from '@/assets/dir_nw.png'
export {default as OK} from '@/assets/dir_ok.png'
export {default as Bottom} from '@/assets/dir_s.png'
export {default as BottomRight} from '@/assets/dir_se.png'
export {default as Up} from '@/assets/dir_sky.png'
export {default as BottomLeft} from '@/assets/dir_sw.png'
export {default as Left} from '@/assets/dir_w.png'
export const names = [
  'Forward',
  'Back',
  'TopLeft',
  'Top',
  'TopRight',
  'Left',
  'OK',
  'Right',
  'BottomLeft',
  'Bottom',
  'BottomRight',
  'Up',
  'Down'
]